export default {
  'login.form.title': '登录 Admin Center',
  'login.form.userName.errMsg': 'Username cannot be empty',
  'login.form.password.errMsg': 'Password cannot be empty',
  'login.form.login.errMsg': 'Login error, refresh and try again',
  'login.form.login.success': 'welcome to use',
  'login.form.userName.placeholder': 'Username: admin',
  'login.form.password.placeholder': 'Password: admin',
  'login.form.rememberPassword': 'Remember password',
  'login.form.forgetPassword': 'Forgot password',
  'login.form.login': 'login',
  'login.form.login.kook': 'login with kook',
  'login.form.register': 'register account',
  'login.banner.slogan1': 'Out-of-the-box high-quality template',
  'login.banner.subSlogan1':
    'Rich page templates, covering most typical business scenarios',
  'login.banner.slogan2': 'Built-in solutions to common problems',
  'login.banner.subSlogan2':
    'Internationalization, routing configuration, state management everything',
  'login.banner.slogan3': 'Access visualization enhancement tool AUX',
  'login.banner.subSlogan3': 'Realize flexible block development',
};
